import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["amountInput", "summaryAmount", "summaryTotal", "submitText", "submitButton", "quickAmounts"];

  declare amountInputTarget: HTMLInputElement;
  declare summaryAmountTarget: HTMLElement;
  declare summaryTotalTarget: HTMLElement;
  declare submitTextTarget: HTMLElement;
  declare submitButtonTarget: HTMLButtonElement;
  declare quickAmountsTarget: HTMLElement;

  connect() {
    this.updateSummary();
    this.amountInputTarget.addEventListener("input", () => this.updateSummary());
    
    // Add Turbo form handlers for loading state
    this.element.addEventListener("turbo:submit-start", () => this.showLoading());
    this.element.addEventListener("turbo:submit-end", () => this.hideLoading());
  }

  showLoading() {
    const amount = parseFloat(this.amountInputTarget.value) || 0;
    try { window.umami?.track("topup-submitted", { amount }) } catch {}
    this.submitButtonTarget.disabled = true;
    this.submitTextTarget.innerHTML = `<span class="loading loading-spinner loading-sm"></span> Processing...`;
  }

  hideLoading() {
    this.submitButtonTarget.disabled = false;
    this.updateSummary(); // Reset button text
  }

  selectAmount(event: Event) {
    const button = event.currentTarget as HTMLButtonElement;
    const amount = button.dataset.amount;

    if (amount) {
      this.amountInputTarget.value = amount;
      this.updateSummary();

      // Update button styles
      this.quickAmountsTarget.querySelectorAll("button").forEach((btn) => {
        btn.classList.remove("btn-primary");
        btn.classList.add("btn-outline");
      });
      button.classList.remove("btn-outline");
      button.classList.add("btn-primary");
    }
  }

  updateSummary() {
    const amount = parseFloat(this.amountInputTarget.value) || 0;
    const formatted = this.formatCurrency(amount);

    this.summaryAmountTarget.textContent = formatted;
    this.summaryTotalTarget.textContent = formatted;
    this.submitTextTarget.textContent = `Pay ${formatted}`;
  }

  private formatCurrency(amount: number): string {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  }
}

